<template>
  <el-button @click="store.step--" v-if="store.step > 1">
    {{ text || 'Back' }} 
  </el-button>
</template>

<script setup lang="ts">
import { useDonationFormsStore } from '../store';
const props = defineProps(['text']);
const store = useDonationFormsStore();

</script>